<template>
  <pagelayout :contentBgcolor="isDark && '#eeeeee'">
    <appbar :title="`快三${app_my_config.lotteryCredit.name}说明`" />
    <div class="guide">
      <div class="tit">大小骰宝</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">{{ app_my_config.k3DXDSPickerTitle.name }}</td>
            <td>
              投注开奖点数总{{ app_my_config.lotteryTotal.name }}的{{ app_my_config.k3DA.name }}、{{
                app_my_config.k3XIAO.name
              }}、{{ app_my_config.k3DAN.name }}、{{ app_my_config.k3SHUANG.name }}形态。3-10为{{
  app_my_config.k3XIAO.name
}}，11-18为{{ app_my_config.k3DA.name }}。3、5、7、9、11、13、15、17为{{
  app_my_config.k3DAN.name
}}，4、6、8、10、12、14、16、18为{{ app_my_config.k3SHUANG.name }}。
            </td>
          </tr>
          <tr>
            <td>如：投注{{ app_my_config.k3DA.name }}；开奖号码为456，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">三军</td>
            <td>
              从1-6共6个点数中选择1个点数组成1注，当期所有3个开奖点数中包含所选点数，视为中奖，其余情形视为未中奖。如果超过1个开奖点数与所选点数相同，奖金将中奖点数个数倍增。
            </td>
          </tr>
          <tr>
            <td>如：开奖点数 1 1 3，则投注 1 或投注 3 皆为中奖，其中投注 1 为2倍派彩，投注 3 为1倍派彩。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">围骰</td>
            <td>中奖点数的【第一颗、第二颗、第三颗】点数都相同，与所选点数都相同。</td>
          </tr>
          <tr>
            <td>
              如：中奖点数为111、333、666等，中奖点数的【第一颗、第二颗、第三颗】点数都相同，与所选点数都相同视为中奖，其它视为不中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">全骰</td>
            <td>当期所有3个开奖点数都相同。</td>
          </tr>
          <tr>
            <td>如：投注 全骰，开奖点数 1 1 1、2 2 2、3 3 3 等即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">点数</td>
            <td>
              当期所有3个开奖点数总{{
                app_my_config.lotteryTotal.name
              }}（3-18）。若投注内容符合当期开奖结果，视为中奖，其余情形视为未中奖。
            </td>
          </tr>
          <tr>
            <td>如：投注 8，开奖点数 1 1 6、2 3 3、1 3 4 等即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">长牌</td>
            <td>
              从1-6共6个点数中选择2个不重复的点数组成1注，当期所有3个开奖点数中包含所选点数，视为中奖，其余情形视为未中奖。
            </td>
          </tr>
          <tr>
            <td>如：开奖点数 1 2 3，则投注 1 2、2 3、1 3 即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">短牌</td>
            <td>中奖点数的【第一颗、第二颗、第三颗】任两颗点数相同时，视为中奖。</td>
          </tr>
          <tr>
            <td>投注方案为：1,1；开奖号码为112、121、211等视为中奖，其它视为不中奖。注：开豹子视为不中奖。</td>
          </tr>
        </tbody>
      </table>
    </div>
  </pagelayout>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
export default {
  mixins: [appConfigMixins]
}
</script>

<style lang="scss">
@import '~/assets/common/page/guide.scss';
</style>
